import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as Func from '../../../../../helpers/functions';
import i18n from "../../../../../constants/initLng";
import action from "../../../../../actions";
import * as HMS from "../../../common/component/Index";
import { message, Tooltip, Icon } from 'antd';
import * as RoleComponent from '../component/CommonComponent';
import Input from './../../../common/component/Input';

const defaultValue = {
    action: "CREATE",
    data: { permissions: [] },
    isSubmit: false,
    isFetching: false,
    isFetchingUpdate: false,
    isGetItem: false,
    validation: {},
};

class ActionComponent extends Component {

    state = defaultValue;

    componentDidMount() {
        const { match } = this.props;
        if (Object.keys(match.params).length > 0) {
            this.setState({ action: "UPDATE" });
            this.props.onGetItemRole({ id: match.params.id, props: this.props });
        } else {
            this.setState({ data: { permissions: [] }})
        }
    }

    validation = (field, reload) => {
        const { t } = this.props;
        let data = this.state.data;
        let result = {};
        if (!reload) {
            let validate = {
                required: {
                    name: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.role.name`))
                }
            };
            let valueValidate = {};
            result = Func.multipleValidate(data, validate, valueValidate);
        } else {
            let validation = this.state.validation;
            result = Func.reloadValidation(validation, field)
        }
        this.setState({ validation: result });
        return result;
    };

    componentWillReceiveProps(nextProps) {
        this.setState({
            isSubmit: nextProps.roles.isSubmit,
            isGetItem: nextProps.roles.isGetItem,
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.roles.dataUpdate !== prevProps.roles.dataUpdate) {
            this.setState({
                data: this.props.roles.dataUpdate,
            })
        }
    }

    onChange = (e) => {
        let params = Func.getValueForm(e);
        this.setState({
            data: {
                ...this.state.data,
                [params.name]: typeof params.value === 'string' ? params.value.trimLeft() : params.value,
            }
        });
        this.validation(params.name, true)
    };

    onSubmit = (e) => {
        e.preventDefault();
        let result = this.validation();
        if (Object.keys(result).length < 1) {
            if (this.state.action === "CREATE") {
                let dataCreate = this.state.data;
                this.props.onCreateRole({ data: dataCreate, props: this.props });
            } else if (this.state.action === "UPDATE") {
                let dataUpdate = this.state.data;
                this.props.onUpdateRole({ data: { ...dataUpdate, id: this.state.data.id }, props: this.props });
            }
        } else {
            message.error(i18n.t('validation.checkForm'))
        }
    };

    onSetPermissions = (permissions) => {
        this.setState({
            data: {
                ...this.state.data,
                permissions: permissions
            }
        })
    };

    render() {
        const { t } = this.props;
        const { data, validation, isSubmit, isGetItem, action } = this.state;
        return (
            <Fragment>
                <HMS.LoadingComponent spinning={isSubmit}>
                    <HMS.PageListComponent>
                        <HMS.HeaderListComponent
                            path={this.props.match.path}
                            groupPath="roles"
                            titleHeader={
                                action === "CREATE" ?
                                    Func.capitalizeFirstLetter((`${t('action.create')} ${t('item.role.title')}`).toLowerCase())
                                    : Func.capitalizeFirstLetter((`${t('action.update')} ${t('item.role.title')}`.toLowerCase()))
                            }
                        />
                        <HMS.FormActionComponent
                            onSubmit={this.onSubmit}
                            isSubmit={isSubmit}
                            action={action}
                            isGetItem={isGetItem}
                            findParentRoute={() => Func.findParentRoute('roles', this.props)}
                            onChangeActive={this.onChange}
                            submitButtonRight={true}
                        >
                            <HMS.FormWrapperItem>
                                <div className="col-md-8 offset-md-2 mt-3">
                                    <HMS.FormWrapperInputComponent
                                        isRequired={true}
                                        isValidation={true}
                                        dataValidation={data.name}
                                        validation={validation.name}
                                        labelTitle={t(`item.role.name`)}
                                    >
                                        <Input placeholder="" type="text"
                                            className="form-control"
                                            name="name" onChange={this.onChange}
                                            value={Func.checkUndefine(data.name)} />
                                    </HMS.FormWrapperInputComponent>
                                </div>
                                <div className="col-md-8 offset-md-2">
                                    <RoleComponent.RolePermission
                                        permissions={data.permissions}

                                        onSetPermissions={this.onSetPermissions}
                                    >
                                    </RoleComponent.RolePermission>
                                </div>
                            </HMS.FormWrapperItem>
                        </HMS.FormActionComponent>
                    </HMS.PageListComponent>
                </HMS.LoadingComponent>
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        roles: state.roleReducer,
        file: state.uploadReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        onCreateRole: (params) => {
            dispatch(action.createRoleAction(params))
        },
        onUpdateRole: (id) => {
            dispatch(action.updateRoleAction(id))
        },
        onGetItemRole: (id) => {
            dispatch(action.getUpdateRoleAction(id))
        },
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ActionComponent)));
